import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const farmersSlice = createSlice({
  name: "Farmer",
  initialState: {
    isLoading: false,
    farmer: {},
    farmerList: [],
    farmerFarmDetails: {},
    farmerDetails: {},
    farmerOrders: [],
  },
  reducers: {
    // login
    getFarmersRequest: (state) => setLoading(state, true),
    getFarmersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "farmerList"),
    getFarmersFailure: (state) => setLoading(state, false),

    getFarmerDetailsRequest: (state) => setLoading(state, true),
    getFarmerDetailsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "farmerDetails"),
    getFarmerDetailsFailure: (state) => setLoading(state, false),

     // Delete farmer actions
     deleteFarmerRequest: (state) => setLoading(state, true),
     deleteFarmerSuccess: (state, action) => 
       setSuccessWithData(state, action.payload, "suppliersList"),
     deleteFarmerFailure: (state) => setFailure(state),

    // New actions for farmer farm details
    getFarmerFarmDetailsRequest: (state) => setLoading(state, true),
    getFarmerFarmDetailsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "farmerFarmDetails"),
    getFarmerFarmDetailsFailure: (state) => setFailure(state),

    // New actions for farmer orders
    getFarmerOrdersRequest: (state) => setLoading(state, true),
    getFarmerOrdersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "farmerOrders"),
    getFarmerOrdersFailure: (state) => setFailure(state),

    // Assign consultant
        assignConsultantRequest: (state) => setLoading(state, true),
        assignConsultantSuccess: (state) => setLoading(state, false),
        assignConsultantFailure: (state) => setLoading(state, false),

        // Change consultant
        changeConsultantRequest: (state) => setLoading(state, true),
        changeConsultantSuccess: (state) => setLoading(state, false),
        changeConsultantFailure: (state) => setLoading(state, false),
  },
});

export const { 
  getFarmersRequest, 
  getFarmersSuccess, 
  getFarmersFailure, 
  getFarmerDetailsRequest, 
  getFarmerDetailsSuccess, 
  getFarmerDetailsFailure, 
  getFarmerFarmDetailsRequest,
  getFarmerFarmDetailsSuccess,
  getFarmerFarmDetailsFailure,
  getFarmerOrdersRequest,
  getFarmerOrdersSuccess,
  getFarmerOrdersFailure,
  deleteFarmerRequest,
  deleteFarmerSuccess,
  deleteFarmerFailure,
  assignConsultantRequest,
  assignConsultantSuccess,
  assignConsultantFailure,
  changeConsultantRequest,
  changeConsultantSuccess,
  changeConsultantFailure,
 } =
  farmersSlice.actions;

export const farmerReducerSlice = farmersSlice.reducer;
